export default {"src":"__ASTRO_ASSET_IMAGE__D5me6Gnq__","width":231,"height":231,"format":"svg"}